type Props = {
    percentage: number
    minPercentage?: number
}

export function AdviserFlowProgressBar({ percentage, minPercentage = 25 }: Props) {
    const normalizedPercentage = Math.min(100, Math.max(minPercentage, percentage))

    return (
        <div className="self-stretch inline-flex flex-col justify-start items-start gap-6">
            <div className="self-stretch h-2 relative">
                <div className="w-full h-2 left-0 top-0 absolute bg-primary-dust rounded-[40px]" />
                <div
                    className="h-2 left-0 top-0 absolute bg-brand-primary-lime rounded-[40px] transition-[width] duration-300 ease-out"
                    style={{ width: `${normalizedPercentage}%` }}
                />
            </div>
        </div>
    )
}
